import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Panel, Pill } from "@/components/admin/AdminUI";

export const toDarkRow = (p) => (p ? { store_product_id: p.store_product_id, price: String(p.price_usd ?? ""), active: p.active !== false } : null);
export const darkError = (r) => (r && !(+r.price > 0 && +r.price <= 1000) ? "Enter a price above $0 and up to $1000." : null);
export const darkChanges = (o, r) => (o && r && (+o.price_usd !== +r.price || (o.active !== false) !== r.active)
  ? [`Dark look (lifetime): $${o.price_usd} ${o.active !== false ? "on" : "off"} → $${r.price || "?"} ${r.active ? "on" : "off"}`] : []);
export const darkPayload = (r) => ({ store_product_id: r.store_product_id, price_usd: +r.price, active: r.active });

// The one-time "Keep dark" product. Same row style as the subscription tables; the store ID is fixed in the app and the store.
export default function DarkLifetimeCard({ row, error, onChange }) {
  if (!row) return null;
  return (
    <section className="mt-10 space-y-4" aria-labelledby="dark-title" data-testid="pricing-dark-lifetime">
      <div><h2 id="dark-title" className="text-lg font-semibold">One-time purchases</h2>
        <p className="cw-muted text-xs">Bought once, kept forever on the account. Nothing renews.</p></div>
      <Panel className="overflow-hidden">
        <div className="px-6 pb-2 pt-5"><h3 className="font-semibold">Dark look (lifetime)</h3></div>
        <div className="overflow-x-auto px-4 pb-3">
          <table className="w-full min-w-[640px] text-left" data-testid="dark-lifetime-table">
            <thead><tr className="cw-muted text-xs">
              <th className="px-2 py-2 font-medium">Price (USD)</th><th className="px-2 py-2 font-medium">Store product ID</th><th className="px-2 py-2 font-medium">Active</th>
            </tr></thead>
            <tbody><tr data-testid="dark-lifetime-row">
              <td className="px-2 py-3 align-top">
                <div className="relative w-32">
                  <span className="cw-muted pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm">$</span>
                  <Input value={row.price} onChange={(e) => onChange("price", e.target.value.replace(/[^\d.]/g, ""))} inputMode="decimal" aria-label="Dark look lifetime price"
                    aria-invalid={!!error} className={`h-10 rounded-lg bg-white pl-6 tabular-nums ${error ? "border-destructive" : ""}`} data-testid="dark-lifetime-price-input" />
                </div>
                {error && <p className="cw-error mt-1 text-xs" role="alert" data-testid="dark-lifetime-price-error">{error}</p>}
              </td>
              <td className="px-2 py-3 align-top"><div className="flex h-10 items-center"><Pill className="font-mono" data-testid="dark-lifetime-product-id">{row.store_product_id}</Pill></div></td>
              <td className="px-2 py-3 align-top"><div className="flex h-10 items-center">
                <Switch checked={row.active} onCheckedChange={(v) => onChange("active", v)} aria-label="Dark look lifetime active" data-testid="dark-lifetime-active-toggle" />
              </div></td>
            </tr></tbody>
          </table>
          <p className="cw-muted px-2 pb-2 text-xs" data-testid="dark-lifetime-help">
            Same product ID on Apple and Google; it can&apos;t be changed here. The free trial, who keeps Dark after it, and whether the app offers this purchase are in Settings → Appearance.
          </p>
        </div>
      </Panel>
    </section>
  );
}
